var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-predefined chat-bubble",class:{
    'from-customer': _vm.message.DIRECTION === 'customer2club',
    'from-club': _vm.message.DIRECTION === 'club2customer',
  }},[_c('MessageDate',{attrs:{"timestamp":_vm.message.TIMESTAMP}}),(_vm.message.data_predefined === 'cancel_element')?_c('CancelItem',{attrs:{"reasons":_vm.cancelReasons,"token":_vm.token}}):_vm._e(),(_vm.message.data_predefined === 'while_waiting')?_c('WhileWaiting'):_vm._e(),(_vm.message.data_predefined === 'transmit_document')?_c('TransmitDocument'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }